import type { StudentQuestionListItem } from "../../Questions/types"
import {
  buildTopicPath,
  stripHtml,
} from "../../Questions/utils/mapQuestionCard"
import type { BookmarkCardViewModel } from "../types"

export const mapBookmarkCard = (
  item: StudentQuestionListItem
): BookmarkCardViewModel => ({
  id: item.id,
  subjectTitle: item.subject_title || "Subject",
  yearLabel: item.year != null ? String(item.year) : "",
  topicPath: buildTopicPath(item),
  snippet: stripHtml(item.question) || "No preview available",
  hasSolution: !!stripHtml(item.solution),
})
